/* populate hidden fields with values from localStorage */
function populateHiddenFields(formEl) {
    formEl.querySelectorAll('input[type="hidden"][data-value]').forEach((input) => {
        const key = input.dataset.value;
        if (!key) return;
        const val = localStorage.getItem(key);
        if (val !== null) input.value = val;
    });
}

function populateTrackingFields(formEl) {
    const utmDataJson = localStorage.getItem('utmData');
    const utmParams = (utmDataJson && utmDataJson.length > 20)
        ? JSON.parse(utmDataJson)
        : (window.bestUtmData || {});

    var deviceType = "desktop";
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        deviceType = "mobile";
    }

    const trackingIds = {
        gclid: localStorage.getItem('gclid'),
        fbclid: localStorage.getItem('fbclid'),
        ttclid: localStorage.getItem('ttclid'),
        landing_page: localStorage.getItem('landingPage'),
        device: deviceType
    };

    if (!utmParams.utm_adgroup && trackingIds.landing_page && trackingIds.landing_page.includes('adgroup=')) {
        utmParams.utm_adgroup = trackingIds.landing_page.split('adgroup=')[1].split('&')[0];
    }

    [...Object.entries(utmParams), ...Object.entries(trackingIds)].forEach(([key, value]) => {
        if (value) {
            const hiddenField = formEl.querySelector(`input[data-value="${key}"]`);
            if (hiddenField) hiddenField.value = value;
        }
    });
}

function populateAbTestsField(formEl) {
    const fld = formEl.querySelector('input[data-value="ab_tests"]');
    if (!fld) return;

    try {
        const stored = localStorage.getItem('ig_historical_experiments');
        const experiments = stored ? JSON.parse(stored) : [];

        if (!experiments.length) {
            fld.value = '';
            return;
        }

        let abtData = '';
        experiments.forEach((experiment) => {
            const expName = experiment.name || 'Unknown Experiment';
            const vName = experiment.variant || 'unknown';
            abtData += `${expName} : ${vName}; `;
        });

        fld.value = abtData.trim();
    } catch (error) {
        console.error('Error retrieving experiments from storage:', error);
    }
}

function populateContextFields(formEl) {
    const requestUuid = localStorage.getItem('request_uuid') ?? window.requestUuid;

    const requestIdField = formEl.querySelector('input[data-value="request_id"]');
    if (requestIdField) requestIdField.value = requestUuid;

    const visitorIdField = formEl.querySelector('input[data-value="mc_visitor_id"]');
    if (visitorIdField) visitorIdField.value = localStorage.getItem('mc_visitor_id');

    let referrer = (document.referrer ?? "").toLowerCase();
    const utmContentField = formEl.querySelector('input[data-value="utm_content"]');
    if (utmContentField && referrer.includes("pages/affordable-custom-closets-2")) {
        utmContentField.value = "matisyahu_facebook_campaign";
    }

    const engagedUserField = formEl.querySelector('input[data-value="mc_engaged_user"]');
    if (engagedUserField) engagedUserField.value = getCookie('mc_engaged_user') || '';
}

/* handle form submission */
function orderSampleFormSubmitted(formEl) {
    populateHiddenFields(formEl);
    populateTrackingFields(formEl);
    populateAbTestsField(formEl);
    populateContextFields(formEl);

    if (!formEl.checkValidity()) {
        formEl.reportValidity();
        return false;
    }

    const section = formEl.closest('.osb-form-section');
    const otpEnabled = section && section.dataset.otpEnabled === 'true';

    if (otpEnabled && formEl.dataset.otpVerified !== 'true') {
        startPhoneVerification(formEl, section);
        return false;
    }

    return proceedWithRecaptchaAndSubmit(formEl, section);
}

function proceedWithRecaptchaAndSubmit(formEl, section) {
    if (section && section.querySelector('#recaptcha-score') != null) {
        const submitBtn = section.querySelector('.form-submit');
        if (submitBtn) submitBtn.style.display = 'none';
        getRecaptchaAndSubmit(() => submitOrderSampleForm(formEl));
    } else {
        submitOrderSampleForm(formEl);
    }
    return false;
}

function formatPhoneE164(rawPhone) {
    const digits = rawPhone.replace(/\D/g, '');
    if (digits.length === 10) return '+1' + digits;
    if (digits.length === 11 && digits.startsWith('1')) return '+' + digits;
    return '+' + digits;
}

function startPhoneVerification(formEl, section) {
    const phoneInput = formEl.querySelector('[name="' + section.dataset.otpPhoneField + '"]');
    const rawPhone = phoneInput ? phoneInput.value.trim() : '';
    if (!rawPhone) {
        alert('Please enter a phone number.');
        return;
    }
    const phone = formatPhoneE164(rawPhone);

    const otpPanel = section.querySelector('.osb-otp-panel');
    const submitBtn = section.querySelector('.form-submit');
    const originalBtnText = submitBtn ? submitBtn.textContent : '';

    if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending code…';
    }

    const cacheBuster = '&_=' + Date.now();
    const sendUrl = section.dataset.otpSendUrl + '?phone=' + encodeURIComponent(phone) + cacheBuster;

    fetch(sendUrl, { cache: 'no-store' })
        .then((res) => res.json())
        .then((data) => {
            if (!data.ok) throw new Error(data.error || 'Failed to send code');

            const card = formEl.closest('.osb-form-card') || formEl.parentElement;
            const head = card.querySelector('.osb-headings-wrapper');
            if (head) head.style.display = 'none';

            formEl.style.display = 'none';
            otpPanel.querySelector('.osb-otp-phone').textContent = phone;
            otpPanel.hidden = false;

            const header = document.querySelector('.site-header');
            const headerOffset = header ? header.getBoundingClientRect().height : 0;
            const top = otpPanel.getBoundingClientRect().top + window.pageYOffset - headerOffset - 100;
            window.scrollTo({ top: top, behavior: 'smooth' });

            setTimeout(() => {
                otpPanel.querySelector('.osb-otp-input').focus();
            }, 400);
        })
        .catch((err) => {
            alert(err.message || 'Could not send code. Please try again.');
        })
        .finally(() => {
            if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.textContent = originalBtnText;
            }
        });
}

function verifyEnteredCode(formEl, section) {
    const otpPanel = section.querySelector('.osb-otp-panel');
    const verifyBtn = otpPanel.querySelector('.osb-otp-verify-btn');
    const errorEl = otpPanel.querySelector('.osb-otp-error');
    const codeInput = otpPanel.querySelector('.osb-otp-input');

    const rawPhone = formEl.querySelector('[name="' + section.dataset.otpPhoneField + '"]').value.trim();
    const phone = formatPhoneE164(rawPhone);
    const code = codeInput.value.trim();

    if (!code) {
        errorEl.textContent = 'Please enter the code.';
        errorEl.hidden = false;
        return;
    }

    errorEl.hidden = true;
    verifyBtn.disabled = true;
    verifyBtn.textContent = 'Verifying…';

    const cacheBuster = '&_=' + Date.now();
    const url = section.dataset.otpVerifyUrl
        + '?phone=' + encodeURIComponent(phone)
        + '&code=' + encodeURIComponent(code)
        + cacheBuster;

    fetch(url, { cache: 'no-store' })
        .then((res) => res.json())
        .then((data) => {
            if (!data.ok) {
                errorEl.textContent = 'Incorrect code. Please try again.';
                errorEl.hidden = false;
                return;
            }

            formEl.dataset.otpVerified = 'true';
            otpPanel.hidden = true;

            const loadingEl = section.querySelector('.osb-loading');
            if (loadingEl) loadingEl.hidden = false;

            orderSampleFormSubmitted(formEl);
        })
        .catch(() => {
            errorEl.textContent = 'Something went wrong. Please try again.';
            errorEl.hidden = false;
        })
        .finally(() => {
            verifyBtn.disabled = false;
            verifyBtn.textContent = 'Verify and submit';
        });
}

function initOtpHandlers() {
    document.querySelectorAll('.osb-form-section[data-otp-enabled="true"]').forEach((section) => {
        const formEl = section.querySelector('#orderSampleBoxForm');
        const otpPanel = section.querySelector('.osb-otp-panel');
        if (!formEl || !otpPanel) return;

        const verifyBtn = otpPanel.querySelector('.osb-otp-verify-btn');
        const resendBtn = otpPanel.querySelector('.osb-otp-resend-btn');
        const codeInput = otpPanel.querySelector('.osb-otp-input');

        verifyBtn.addEventListener('click', () => verifyEnteredCode(formEl, section));

        codeInput.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                verifyEnteredCode(formEl, section);
            }
        });

        resendBtn.addEventListener('click', () => {
            resendBtn.disabled = true;
            let secondsLeft = 30;
            const originalText = resendBtn.textContent;
            resendBtn.textContent = 'Resend in ' + secondsLeft + 's';

            const countdown = setInterval(() => {
                secondsLeft -= 1;
                if (secondsLeft <= 0) {
                    clearInterval(countdown);
                    resendBtn.disabled = false;
                    resendBtn.textContent = originalText;
                } else {
                    resendBtn.textContent = 'Resend in ' + secondsLeft + 's';
                }
            }, 1000);

            startPhoneVerification(formEl, section);
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOtpHandlers);
} else {
    initOtpHandlers();
}

function submitOrderSampleForm(formEl) {
    const section = formEl.closest('.osb-form-section');
    const card = formEl.closest('.osb-form-card') || formEl.parentElement;

    const ds = (section && section.dataset) || {};
    const title = ds.tyTitle || 'Your samples are on their way';
    const text = ds.tyText || "We've got your request. A confirmation email is headed to your inbox, and your box should arrive in 5-7 business days.";
    const waitTxt = ds.tyWait || 'While you wait…';
    const c1t = ds.tyCta1Text, c1u = ds.tyCta1Url;
    const c2t = ds.tyCta2Text, c2u = ds.tyCta2Url;

    formEl.style.display = 'none';
    const head = card.querySelector('.osb-headings-wrapper');
    if (head) head.style.display = 'none';
    const otpPanel = card.querySelector('.osb-otp-panel');
    if (otpPanel) otpPanel.style.display = 'none';
    const loadingEl = card.querySelector('.osb-loading');
    if (loadingEl) loadingEl.hidden = true;

    let ctas = '';
    if ((c1t && c1u) || (c2t && c2u)) {
        ctas = '<div class="osb-ty-ctas">';
        if (c1t && c1u) ctas += '<a class="osb-ty-btn osb-ty-btn-primary" href="' + c1u + '">' + c1t + '</a>';
        if (c2t && c2u) ctas += '<a class="osb-ty-btn osb-ty-btn-secondary" href="' + c2u + '">' + c2t + '</a>';
        ctas += '</div>';
    }

    const msg = document.createElement('div');
    msg.className = 'osb-thank-you';
    msg.innerHTML =
        '<span class="osb-ty-pill">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"></rect><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path></svg>' +
        'Confirmed' +
        '</span>' +
        '<h3 class="osb-ty-title">' + title + '</h3>' +
        '<p class="osb-ty-text">' + text + (ctas ? '<br><br>' + waitTxt : '') + '</p>' +
        ctas;
    card.appendChild(msg);

    const header = document.querySelector('.site-header');
    const headerOffset = header ? header.getBoundingClientRect().height : 0;
    const top = msg.getBoundingClientRect().top + window.pageYOffset - headerOffset - 100;
    window.scrollTo({ top: top, behavior: 'smooth' });

    formEl.submit();
}